import { createGlobalStyle } from "styled-components";

const GlobalStyled = createGlobalStyle`
  .not-linked-items-page {

    .filters-block {
      margin: 0 25px;

      .Select-menu-outer, .react-datepicker-popper {
        z-index: 2;
      }

      @media (min-width: 768px) {
        display: flex;
        flex-wrap: wrap;

        >.form-group {
          width: 48%;

          &:nth-of-type(even) {
            margin-left: 2%;
          }
          &:nth-of-type(odd) {
            margin-right: 2%;
          }
        }
      }
    }

    .filters-btn-toolbar {
      margin: 0 -7px;
      padding-top: 0;
      border-top: none;
    }
  }

  .not-linked-items-page-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 70px);

    .not-linked-dirs-table {
      height: 100%;
      display: flex;
      flex-direction: column;

      .table-wrapper {
        overflow: hidden;
      }

      .table-block {
        height: 100%;
      }

      tr.yellow .name {
        border-left: 3px solid yellow;
        padding: 8px !important;
      }
      tr.red .name {
        border-left: 3px solid red;
        padding: 8px !important;
      }
      tr.green .name {
        border-left: 3px solid green;
        padding: 8px !important;
      }
    }

    .not-linked-emails-container {
      .table-wrapper {
        overflow: hidden;
      }

      .table-block {
        height: 100%;
      }

      tr {
        td, th {
          word-break: break-all;

          &.expand {
            width: 20px;

            .fa-minus-square, .fa-plus-square {
              color: #757575;

              &:hover {
                color: #282828;
                cursor: pointer;
              }
            }
          }
          &.from {
            width: calc(12% - 20px);
          }
          &.to {
            width: 12%;
          }
          &.subject {
            width: 30%;
          }
          &.date {
            width: 13%;
          }
          &.tags {
            width: 15%;
          }
          &.actions {
            width: 12%;
          }
        }
      }
    }
  }

  .modal-content > div {
    max-height: calc(100vh - 75px) !important;
  }

  .modal-body {
    overflow: hidden !important;
    display: flex;
  }

  .modal-body .container-fluid {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /*height: 100%;*/
    flex: 1 auto;

    .tags-overlay-content {
      overflow: auto;
    }
  }

  body:not(.login-layout) {
    overflow-y: unset !important;
  }

  html:has(.overlay-modal) {
    overflow: hidden;
  }
`;

export default GlobalStyled;